module.exports = __webpack_public_path__ + "img/analytics.ddc262a4.svg";